import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';


import { ApiHelperService } from '../../core/api-helper.service';
import { BillingInfo } from '../billing-info/billing-info.model';
import { WidgetConfig } from '../lead/lead.model';
import { PaymentPlan } from '../payment-plan/payment-plan.model';
import { Organization, OrganizationPreview } from './organization.model';

// TODO (jacob): This whole service should be refactored
// TODO (jacob): This should update the state service where appropriate
@Injectable({
    providedIn: 'root'
})
export class OrganizationService {

    private widgetConfig: Promise<WidgetConfig> | null = null;

    private options = { authenticate: true, setRoot: true };

    constructor(private apiHelper: ApiHelperService) { }

    // TODO (jacob): Consider moving this
    //               I'll need to add a widgetConfig table
    public getWidgetConfig(organizationId: string): Promise<WidgetConfig> {

        // TODO (jacob): set widget config to null when the organization changes
        // TODO (jacob): This can't exist...
        if (this.widgetConfig == null)
            this.widgetConfig = this.apiHelper.apiCallSane(
                '/widget-config',
                'GET',
                this.apiHelper.getDefaultHeaders(),
                { organizationId: organizationId },
                null,
                this.options
            );

        return this.widgetConfig;
    }

    public patch(id: string, org: Partial<Organization>): Promise<Organization> {
        return this.apiHelper.apiCallSane(
            '/organization',
            'PATCH',
            this.apiHelper.getDefaultHeaders(),
            { id },
            org,
            this.options);
    }

    public setWidgetConfig(config: WidgetConfig): Promise<void> {
        this.widgetConfig = Promise.resolve(config);
        return this.apiHelper.apiCallSane(
            '/widget-config',
            'PUT',
            this.apiHelper.getDefaultHeaders(),
            null,
            JSON.stringify(config),
            this.options
        );
    }

    public async getOrganizationById(id: string): Promise<Organization> {
        return this.apiHelper.apiCallSane(
            '/organization',
            'GET',
            this.apiHelper.getDefaultHeaders(),
            { id: id },
            null,
            this.options
        ).then((org: Partial<Organization>) => new Organization(org));
    }

    disableOrganization(id: string): Promise<Organization> {
        return this.apiHelper.apiCallSane(
            '/organization/disable',
            'PUT',
            this.apiHelper.getDefaultHeaders(),
            { id },
            null,
            this.options
        );
    }

    enableOrganizationWithNew(id: string, billingInfo: Partial<BillingInfo>, paymentToken: string, paymentPlan: PaymentPlan): Promise<void> {
        return this.apiHelper.apiCallSane(
            '/organization/enable-with-new',
            'POST',
            this.apiHelper.getDefaultHeaders(),
            { id },
            { billingInfo, paymentToken, paymentPlan },
            this.options
        ).then(() => {});
    }

    enableOrganizationWithSaved(id: string): Promise<void> {
        return this.apiHelper.apiCallSane(
            '/organization/enable-with-saved',
            'PUT',
            this.apiHelper.getDefaultHeaders(),
            { id },
            null,
            this.options
        ).then(() => {});
    }

    // TODO (jacob): 
    startBilling(id: string, org: Partial<Organization>): Promise<Organization> {
        console.error(id + org);
        return Promise.resolve(new Organization({}));
    }

    createOrganization(org: Partial<Organization>): Promise<Organization> {
        return this.apiHelper.apiCallSane(
            '/organization',
            'POST',
            this.apiHelper.getDefaultHeaders(),
            null,
            org,
            this.options
        ).then((org: Partial<Organization>) => new Organization(org));
    }

    changePlan(id: string, paymentPlanId: string): Promise<Organization> {
        return this.apiHelper.apiCallSane(
            '/organization',
            'PATCH',
            this.apiHelper.getDefaultHeaders(),
            { id },
            { paymentPlanId },
            this.options
        );
    }

    addFreeCreditsToOrg(id: string, amount: number): Promise<Organization> {
        return this.apiHelper.apiCallSane(
            '/organization/credits-add',
            'POST',
            this.apiHelper.getDefaultHeaders(),
            { id },
            { amount },
            this.options
        );
    }

    updateOrganization(id: string, org: Partial<Organization>): Promise<Organization> {
        return this.apiHelper.apiCallSane(
            '/organization',
            'PATCH',
            this.apiHelper.getDefaultHeaders(),
            { id },
            org,
            this.options
        ).then((org: Partial<Organization>) => new Organization(org));
    }

    getOrganizations(): Promise<Organization[]> {
        return this.apiHelper.apiCallSane(
            '/organizations',
            'GET',
            this.apiHelper.getDefaultHeaders(),
            null,
            null,
            this.options);
    }

    getAnonOrganizations(): Promise<any> {
        return this.apiHelper.apiCallSane(
            '/anon/organization/list',
            'GET',
            this.apiHelper.getDefaultHeaders(),
            null,
            null,
            this.options
        );
    }

    getOrganizationPreviews(): Promise<OrganizationPreview[]> {
        return this.apiHelper.apiCallSane(
            '/organizations/preview',
            'GET',
            this.apiHelper.getDefaultHeaders(),
            null,
            null,
            this.options
        ).then((orgs: Partial<OrganizationPreview>[]) => orgs.map(o => new OrganizationPreview(o)));
    }

    completeSetup(id: string): Promise<Organization> {

        return this.apiHelper.apiCallSane(
            '/organization/complete-setup',
            'POST',
            this.apiHelper.getDefaultHeaders(),
            { id },
            null,
            { authenticate: true, setRoot: true }
        ).then((org: Partial<Organization>) => new Organization(org));
    }

    completeSignupOrganization(userId: string, organization: Partial<{ friendlyName: string; statementsPerMonth: number; totalEmployees: number }>) {
        return this.apiHelper.apiCallSane('/auth/complete-signup-organization',
            'POST',
            this.apiHelper.getDefaultHeaders(),
            null,
            { userId, organization },
            this.options);
    }

    upgradeAccount(id: string, planId: string, userId: string) {
        const headers: HttpHeaders = this.apiHelper.getDefaultHeaders();
        return this.apiHelper.apiCallSane(
            '/organization/upgrade',
            'PUT',
            headers,
            { id },
            { planId, userId },
            this.options
        );
    }

    buyMoreCredits(id: string, count: number) {
        const headers: HttpHeaders = this.apiHelper.getDefaultHeaders();
        return this.apiHelper.apiCallSane('/organization/buy-credits',
            'POST',
            headers,
            { id },
            { count },
            this.options
        );
    }
}
